/**
 * Global Date Utility Functions
 *
 * This file provides consistent date formatting across all modules:
 * - UI Display: dd/MM/yyyy format
 * - Backend Communication: yyyy-MM-dd format
 * - Database Storage: yyyy-MM-dd format
 */
/**
 * Format date for UI display (dd/MM/yyyy)
 * @param date - Date object, string, or null
 * @returns Formatted date string for UI display
 */
export var formatDateForUI = function (date) {
    if (!date)
        return '';
    var d = typeof date === 'string' ? new Date(date) : date;
    return d.toLocaleDateString('en-GB'); // dd/MM/yyyy for UI display
};
/**
 * Format date for backend transmission (yyyy-MM-dd)
 * @param date - Date object or null
 * @returns Formatted date string for backend
 */
export var formatDateForBackend = function (date) {
    if (!date)
        return null;
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    return "".concat(year, "-").concat(month, "-").concat(day);
};
/**
 * Parse date from backend response (handles both yyyy-MM-dd and dd/MM/yyyy)
 * @param dateString - Date string from backend
 * @returns Date object or null
 */
export var parseDateFromBackend = function (dateString) {
    if (!dateString)
        return null;
    // Handle yyyy-MM-dd format (from backend)
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        var _a = dateString.split('-'), year = _a[0], month = _a[1], day = _a[2];
        return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    }
    // Handle dd/MM/yyyy format (fallback)
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
        var _b = dateString.split('/'), day = _b[0], month = _b[1], year = _b[2];
        return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    }
    // Handle other date formats
    var parsed = new Date(dateString);
    return isNaN(parsed.getTime()) ? null : parsed;
};
/**
 * Format date for export/download (dd/MM/yyyy)
 * @param date - Date object or null
 * @returns Formatted date string for export
 */
export var formatDateForExport = function (date) {
    if (!date)
        return null;
    var day = String(date.getDate()).padStart(2, '0');
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var year = date.getFullYear();
    return "".concat(day, "/").concat(month, "/").concat(year);
};
/**
 * Check if a string is a valid date
 * @param dateString - Date string to validate
 * @returns True if valid date
 */
export var isValidDate = function (dateString) {
    var date = new Date(dateString);
    return !isNaN(date.getTime());
};
/**
 * Get current date in yyyy-MM-dd format
 * @returns Current date string
 */
export var getCurrentDateForBackend = function () {
    var now = new Date();
    return formatDateForBackend(now) || '';
};
/**
 * Get current date in dd/MM/yyyy format
 * @returns Current date string for UI
 */
export var getCurrentDateForUI = function () {
    var now = new Date();
    return formatDateForUI(now);
};
